import { render, staticRenderFns } from "./TeacherNationality.vue?vue&type=template&id=8c1d78c6"
import script from "./TeacherNationality.vue?vue&type=script&lang=js"
export * from "./TeacherNationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports